exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#recycleImage{\n    width: 100px;\n    max-width: 100%;;\n    text-align: center;\n    margin-bottom: 15px;\n}\n#recycleContainer{\n    text-align: center;\n    margin: 0 40px 70px 40px;\n    color: #646161;\n    font-size: 16px;\n    letter-spacing: 1px;\n    line-height: 25px;\n}\n\n@media (max-width: 740px) { \n    #recycleContainer{\n        padding-top: 90px;\n        text-align: center;\n        margin: 0 40px 70px 40px;\n        color: #646161;\n        font-size: 16px;\n        letter-spacing: 1px;\n        line-height: 25px;\n    }\n}", ""]);

// exports
